import app from "../_app";

const searchbar = document.querySelector('.js-searchbar');
const searchTriggers = [...document.querySelectorAll('.js-search-trigger')];

if(searchbar && searchTriggers.length > 0) {
    const clear = searchbar.querySelector('.js-searchbar-clear');

    const clearHandler = () => {
        const searchInput = searchbar.querySelector('.js-searchbar-field');

        searchInput.value = '';
    }

    clear.addEventListener('click', clearHandler);

    const toggleSearch = () => {
        const $input = document.getElementsByClassName('js-searchbar-field')[0];

        if(searchbar.hasAttribute('data-open')) {
            searchbar.removeAttribute('data-open');
            if(document.body.dataset.template === 'index') {
                document.querySelector('.header').classList.remove('force-bg');
            }
            document.querySelector('.searchbar__overlay').classList.remove('active');

            app.unlockBody();

        } else {
            searchbar.setAttribute('data-open', '');
            if(document.body.dataset.template === 'index') {
                document.querySelector('.header').classList.add('force-bg');
            }
            document.querySelector('.searchbar__overlay').classList.add('active');
            $input.focus();

            app.lockBody()
        }
    };

    searchTriggers.map(searchTrigger => searchTrigger.addEventListener('click', toggleSearch));
}
